"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NAMESPACE = exports.TelemetrySpec = exports.ReactionsSpec = exports.LoyaltyProgramsSpec = exports.ConsumableSubsetsSpec = exports.ConsumablesSpec = exports.ConfigsSpec = exports.CommandsSpec = exports.AlarmsSpec = exports.Schema = exports.Catalog = exports.Brands = void 0;
exports.Brands = __importStar(require("./brands"));
exports.Catalog = __importStar(require("./catalog"));
exports.Schema = __importStar(require("./schema"));
var spec_1 = require("./spec");
Object.defineProperty(exports, "AlarmsSpec", { enumerable: true, get: function () { return spec_1.AlarmsSpec; } });
Object.defineProperty(exports, "CommandsSpec", { enumerable: true, get: function () { return spec_1.CommandsSpec; } });
Object.defineProperty(exports, "ConfigsSpec", { enumerable: true, get: function () { return spec_1.ConfigsSpec; } });
Object.defineProperty(exports, "ConsumablesSpec", { enumerable: true, get: function () { return spec_1.ConsumablesSpec; } });
Object.defineProperty(exports, "ConsumableSubsetsSpec", { enumerable: true, get: function () { return spec_1.ConsumableSubsetsSpec; } });
Object.defineProperty(exports, "LoyaltyProgramsSpec", { enumerable: true, get: function () { return spec_1.LoyaltyProgramsSpec; } });
Object.defineProperty(exports, "ReactionsSpec", { enumerable: true, get: function () { return spec_1.ReactionsSpec; } });
Object.defineProperty(exports, "TelemetrySpec", { enumerable: true, get: function () { return spec_1.TelemetrySpec; } });
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Legacy.System';
//# sourceMappingURL=index.js.map